var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: 10,
        paddingLeft: 10
    }
};
export const dpStyles = {
    root: {
        /* styles */
        width: 180
    },
    textField: {
    /* styles */
    },
    icon: {
        /* styles */
        color: '#4177CF'
    },
    callout: {}
};
//# sourceMappingURL=CalendarBarComponent.styles.js.map